import { gql } from '@apollo/client';

export const getAgendaUser = gql /* GraphQL */ `
query GetAgendaUser($userId: ID!) {
    getAgendaUser(userId: $userId) {
      comId
      image
      isConfirmed
      role
      suspended
      type
      hours
      timezone
      FCMtoken
      userId
      username
      __typename
    }
  }
  `;
  
export const shiftsByUser = gql/* GraphQL */ `query ShiftsByUser(
  $filter: ModelAgendaShiftFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $startAt: ModelStringKeyConditionInput
  $userId: ID!
) {
  shiftsByUser(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    startAt: $startAt
    userId: $userId
  ) {
    items {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      performance
      punctuality
      quality
      rate
      role
      shiftAppId
      shiftId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    nextToken
    __typename
  }
}
`;